export enum EnumJobContainer {
    CALENDAR = 'calendar',
    LIST = 'list',
    BLOCKS = 'blocks',
    UNASSIGNED = 'visits', // Future fix - Identify where in the code this exact label is used to style classes. Without it, the entire side panel does not render correct AND drag-and-drop from unassigned does not work
}
